import Card from '@mui/material/Card';
import { makeStyles } from '@material-ui/styles';
import axios from 'src/utils/axios';
import { useLocation } from 'react-router';
import { useParams, useHistory } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import {
  Backdrop,
  CircularProgress,
  Snackbar,
  IconButton,
  Grid,
  Typography,
  Button,
  Box,
  Divider
} from '@material-ui/core';
import Alert from 'src/components/Alert';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { DataGrid } from '@material-ui/data-grid';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: 'Segoe UI',
    width: '100%',
    height: '100%'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#FFA500'
  }
}));

function WarrantyTypeDetail() {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { WarrantyType, WarrantyDesc } = useParams();
  const [warrantyTypeInclude, setWarrantyTypeInclude] = useState([]);
  const [warrantyTypeExclude, setWarrantyTypeExclude] = useState([]);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [loading, setLoading] = React.useState(false);
  const [selectedRowsExclude, setSelectedRowsExclude] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  const columns = [
    { field: 'kul_garanti_tipi', headerName: 'Garanti Tipi', width: 200 },
    { field: 'aciklama', headerName: 'Açıklama', width: 250 },
    { field: 'adsoyad', headerName: 'Kullanıcı', width: 150 },
    {
      field: 'tarih',
      headerName: 'Tarih',
      width: 150,
      renderCell: params => {
        // params.value tarihin string formatını veya Date objesini içerir
        return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
      }
    }
  ];

  const columnsExclude = [
    { field: 'kul_garanti_tipi', headerName: 'Garanti Tipi', width: 200 },
    { field: 'aciklama', headerName: 'Açıklama', width: 250 },
    { field: 'adsoyad', headerName: 'Kullanıcı', width: 150 },
    { field: 'tarih', headerName: 'Tarih', width: 150 },
    {
      field: 'tarih',
      headerName: 'Tarih',
      width: 150,
      renderCell: params => {
        // params.value tarihin string formatını veya Date objesini içerir
        return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
      }
    }
  ];

  useEffect(() => {
    handleGetSarisDynamicWarrantyTypeInclude();
    handleGetSarisDynamicWarrantyTypeExclude();
  }, []);

  const handleGetSarisDynamicWarrantyTypeInclude = () => {
    setLoading(true);
    axios
      .get(`SetSarisDynamicWarrantyTypeInclude/${WarrantyType}`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        setWarrantyTypeInclude(data);
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const handleGetSarisDynamicWarrantyTypeExclude = () => {
    setLoading(true);
    axios
      .get(`SetSarisDynamicWarrantyTypeExclude/${WarrantyType}`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        setWarrantyTypeExclude(data);
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const handleGetSarisDynamiNewcWarrantyTypeInclude = selectedIncludeDataList => {
    setLoading(true);
    axios
      .get(
        `SetSarisDynamicIncludeNewWarranty/${WarrantyType}/${selectedIncludeDataList}`
      )
      .then(response => {
        setLoading(false);
        var data = response.data;
        if (data.ErrorCode == '1000') {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          handleGetSarisDynamicWarrantyTypeInclude();
          handleGetSarisDynamicWarrantyTypeExclude();
          handleClearSelection();
          return;
        } else {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          handleGetSarisDynamicWarrantyTypeInclude();
          handleGetSarisDynamicWarrantyTypeExclude();
          handleClearSelection();
          return;
        }
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const handleGetSarisDynamicNewWarrantyTypeExclude = selectedIncludeDataList => {
    setLoading(true);
    axios
      .get(
        `SetSarisDynamicExcludeNewWarranty/${WarrantyType}/${selectedIncludeDataList}`
      )
      .then(response => {
        setLoading(false);
        var data = response.data;
        if (data.ErrorCode == '1000') {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          handleClearSelection();
          return;
        } else {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          handleGetSarisDynamicWarrantyTypeInclude();
          handleGetSarisDynamicWarrantyTypeExclude();
          handleClearSelection();
          return;
        }
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const handleGoBack = () => {
    const fullPath = location.pathname;
    const basePath = fullPath
      .split('/')
      .slice(0, 2)
      .join('/');
    // Detay sayfasından dönüldüğünü belirtmek için previousPath'i güncelliyoruz.
    localStorage.setItem('previousPath', basePath || '/');
    history.goBack(); // Geri gitmek için useHistory hook'unu kullanıyoruz.
  };
  const handleClearSelection = () => {
    setSelectedRows([]);
    setSelectedRowsExclude([]);
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  return (
    <>
      <Snackbar
        open={uyari}
        autoHideDuration={5000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        />
      </Snackbar>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card sx={{ width: '100%', height: '100%', position: 'relative' }}>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            sx={{ position: 'absolute', top: 16, left: 16 }}
          >
            <IconButton
              style={{ color: '#FF9800' }}
              onClick={() => {
                handleGoBack();
              }}
            >
              <ArrowBackIcon />
            </IconButton>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Typography
              gutterBottom
              variant="h4"
              style={{
                display: 'flex',
                justifyContent: 'center',
                fontWeight: 'bold',
                marginTop: '1rem',
                color: '#FF9800'
              }}
            >
              {WarrantyDesc}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider variant="middle" />
          </Grid>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            style={{ height: '100%', padding: 16 }}
          >
            <Grid item xs={12} sm={10} md={8} lg={6}>
              <div style={{ height: 350, width: '100%' }}>
                <DataGrid
                  rows={warrantyTypeInclude}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: { page: 0, pageSize: 0 }
                    }
                  }}
                  components={{
                    Pagination: () => null // Pagination bileşenini kaldırma
                  }}
                  getRowId={rows => rows.alt_garanti_tipi}
                  pageSizeOptions={[5, 10]}
                  checkboxSelection
                  onSelectionModelChange={newSelection =>
                    setSelectedRowsExclude(newSelection)
                  }
                  selectionModel={selectedRowsExclude}
                />
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100%'
                }}
              >
                <Button
                  sx={{ minWidth: 150, minHeight: 150 }}
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    handleGetSarisDynamicNewWarrantyTypeExclude(
                      selectedRowsExclude
                    );
                  }}
                >
                  Seçili Olanı Sil
                </Button>
              </Box>
            </Grid>
          </Grid>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            style={{ height: '100%', padding: 16 }}
          >
            <Grid item xs={12} sm={10} md={8} lg={6}>
              <div style={{ height: 700, width: '100%' }}>
                <DataGrid
                  rows={warrantyTypeExclude}
                  columns={columnsExclude}
                  initialState={{
                    pagination: {
                      paginationModel: { page: 0, pageSize: 5 }
                    }
                  }}
                  components={{
                    Pagination: () => null // Pagination bileşenini kaldırma
                  }}
                  getRowId={rows => rows.garanti_tipi}
                  pageSizeOptions={[5, 10]}
                  checkboxSelection
                  onSelectionModelChange={newSelection =>
                    setSelectedRows(newSelection)
                  }
                  selectionModel={selectedRows}
                />
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100%'
                }}
              >
                <Button
                  sx={{ minWidth: 150, minHeight: 150 }}
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    handleGetSarisDynamiNewcWarrantyTypeInclude(selectedRows);
                  }}
                >
                  Seçili Olanı Ekle
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </>
  );
}

export default WarrantyTypeDetail;
